import posthog from "posthog-js";
import { useSyncExternalStore } from "react";

/**
 * Feature-flag read via useSyncExternalStore (no useEffect).
 * onFeatureFlags fires on load + each refresh; getFeatureFlag is a sync cached read.
 * Returns variant string, boolean, or undefined (flag unset / posthog not booted).
 */
export function usePostHogFlag(key: string): boolean | string | undefined {
	return useSyncExternalStore(
		(callback) => {
			const unsub = posthog.onFeatureFlags(callback);
			return typeof unsub === "function" ? unsub : () => {};
		},
		() => posthog.getFeatureFlag(key),
		() => undefined,
	);
}
